// extracted by mini-css-extract-plugin
export var typingIndicator = "_qg-0";